import { FunctionalComponent, h } from '@stencil/core';
import { AppRTE } from '.';

interface SectionRTE {
    __component: string;
    data?: any;
}


export const SectionRTE: FunctionalComponent<SectionRTE> = ({ data }) => {

    const { Dark, Text, Center, RemoveTopMargin } = data

    return (
        <section class='uk-container uk-container-xlarge'>
            <div class={`uk-section ${RemoveTopMargin ? 'uk-padding-remove-top' : ''} ${Dark ? 'uk-background-primary-diag uk-light' : (RemoveTopMargin ? 'uk-margin-medium-top' : '')}`}>
                <div class="uk-container">
                    <div class={`${Dark ? 'uk-padding-small' : ''} ${Center ? 'uk-text-center' : ''}`}>
                        <AppRTE markdown={Text} />
                    </div>
                </div>
            </div>
        </section>
    )
};